import template from './invoices.html';
import controller from './invoices.controller';

let invoicesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default invoicesComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/invoices/invoices.component.js